import React from 'react'
import './TestScreen.scss'

function TestScreen() {
    return (
        <div className='grey-background vh-101 custom-table-forTestScreen'>
            <div id="tax-table" className='white-background p-3 mb-3'>
                <div className='custom-table-forTestScreenData'>
                    <div className='custom-table-head'>
                        <div className='row'>
                            <div className='col'>Full Name</div>
                            <div className='col'>Company Name</div>
                            <div className='col'>Oomero ID</div>
                            <div className='col'>Oomero Risk Status</div>
                            <div className='col'>Risk Status</div>
                            <div className='col'>Date Time</div>
                        </div>
                    </div>
                    <div className='custom-table-body'>
                        <div className='row' >
                            <div className='col'>first_name last_name</div>
                            <div className='col'>entity_name</div>
                            <div className='col'>oomero_id</div>
                            <div className='col'>oomero_risk_status</div>
                            <div className='col'>DD/MM/YYYY HH:mm:ss</div>
                            <div className='col'>
                                <p className="action-btn">Start Screening</p>
                            </div>
                        </div>
                        <div className='row' >
                            <div className='col'>first_name last_name</div>
                            <div className='col'>entity_name</div>
                            <div className='col'>oomero_id</div>
                            <div className='col'>oomero_risk_status</div>
                            <div className='col'>DD/MM/YYYY HH:mm:ss</div>
                            <div className='col'>
                                <p className="action-btn">Start Screening</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TestScreen